/**
 * TooltipIcon Component
 *
 * Displays a help icon with tooltip on hover for technical terms.
 * Supports LaTeX rendering in tooltip content using $inline$ or $$display$$ syntax.
 */

import { Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { TOOLTIPS } from '../../data/tooltips';
import { LatexText } from './Latex';

interface TooltipIconProps {
  tooltipKey: string;
  className?: string;
}

export function TooltipIcon({ tooltipKey, className }: TooltipIconProps) {
  const definition = TOOLTIPS[tooltipKey];
  if (!definition) return null;

  return (
    <Tooltip
      title={
        <div style={{ maxWidth: 400 }}>
          <strong>{definition.term}</strong>
          <p style={{ margin: '4px 0', fontSize: '0.9rem' }}>
            <LatexText text={definition.explanation} />
          </p>
          {definition.detailedInfo && (
            <p style={{ margin: '4px 0', fontSize: '0.85rem', opacity: 0.9 }}>
              <LatexText text={definition.detailedInfo} />
            </p>
          )}
          {definition.externalLinks && definition.externalLinks.length > 0 && (
            <div style={{ marginTop: 8 }}>
              {definition.externalLinks.map((link, i) => (
                <a
                  key={i}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#90caf9', textDecoration: 'none', fontSize: '0.85rem' }}
                >
                  {link.title}
                </a>
              ))}
            </div>
          )}
        </div>
      }
      arrow
      placement="top"
    >
      <HelpOutlineIcon
        className={className}
        sx={{ fontSize: 16, ml: 0.5, verticalAlign: 'middle', color: 'text.secondary', cursor: 'help' }}
      />
    </Tooltip>
  );
}
